import { ASSET_STATUS } from '../../constants'

// Shared between AssetDashboard (team-level filtering, using summary counts)
// and AssetTeamPanel (asset-level filtering, once detail is loaded)
export const ASSET_STATUS_FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'outOfService', label: 'Out of Service', summaryKey: 'assetsOutOfService', match: a => a.status === ASSET_STATUS.OUT_OF_SERVICE },
  { key: 'maintenance', label: 'Maintenance', summaryKey: 'assetsMaintenance', match: a => a.status === ASSET_STATUS.MAINTENANCE },
  { key: 'functional', label: 'Functional', summaryKey: 'assetsFunctional', match: a => a.status === ASSET_STATUS.FUNCTIONAL },
  { key: 'standdown', label: 'Pending Stand-down', summaryKey: 'openStanddownsCount', match: a => !!a.openStanddown },
]

export const teamMatchesAssetStatusFilter = (team, filterKey) => {
  if (filterKey === 'all') return true
  const filter = ASSET_STATUS_FILTERS.find(f => f.key === filterKey)
  if (!filter) return true
  return (team.summary?.[filter.summaryKey] ?? 0) > 0
}

export const filterAssetsByStatus = (assets, filterKey) => {
  if (filterKey === 'all') return assets ?? []
  const filter = ASSET_STATUS_FILTERS.find(f => f.key === filterKey)
  if (!filter) return assets ?? []
  return (assets ?? []).filter(filter.match)
}
